import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class OpenScanService {

  apiUrl = 'http://127.0.0.1:5000';

  constructor(private readonly http: HttpClient) { }

  getScannerList(params?: any): Observable<any> {
    let url = this.apiUrl + `/api/scanner/discover`;
    return this.http.get(url, { params });
  }

  scanPdf(scannerId: any, documentData: any): Observable<Blob> {
    const encodedId = encodeURIComponent(scannerId);
    const url = this.apiUrl + `/api/scanner/${encodedId}/scan-direct`;
    return this.http.post(url, documentData, { responseType: 'blob' });
  }

}

